<div [style]="this.topCSS">
  <div *ngIf="!this.searched" class="row" style="width: 100%; margin: auto; margin-top: 20px;">
    <div class="col-12">
      <div class="input-group">
        <span *ngIf="!this.searched" style="border: none; background-color: white;" class="input-group-text" id="basic-addon1"><i class="bi bi-search"></i></span>
        <input (keydown.enter)="this.initiateSearch($event)" (input)="this.onSearchTextChange($event)" style="height: 38px; border: none; border-top-right-radius: 0.25em; border-bottom-right-radius: 0.25em;" type="text" #search class="form-control" formControlName="newPassword" [placeholder]="this.pageDetails().search" [value]="this.searchedText || ''" aria-label="Username" aria-describedby="basic-addon1">
        <button *ngIf="this.searchedText && !this.searched" (click)="this.clearSeacrhedText()" type="button" class="btn bg-transparent" style="margin-left: -45px; z-index: 100;">
          <i class="fa fa-times" style="content: url('/assets/images/home/cross.svg');"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="this.searchedText !== undefined && this.searched " class="row" style="width: 100%; margin: auto; margin-top: 20px; height: 18vh; max-height: 116px;">
    <img style="width: 42px; left: 7px; height: 25px; position: relative; top: 5px;" (click)="this.main()" src="/assets/images/shared/back.svg">
    <div class="col-10" style="padding-right: 0px;">
      <div class="input-group">
        <span *ngIf="!this.searchedText" style="border: none; background-color: white;" class="input-group-text" id="basic-addon1"><i class="bi bi-search"></i></span>
        <input (focus)="this.shouldFiltersBevisible = false" (blur)="this.shouldFiltersBevisible = true" (keydown.enter)="this.initiateSearch($event)" style="height: 38px; border: none; border-top-right-radius: 0.25em; border-bottom-right-radius: 0.25em;" type="text" #search class="form-control" formControlName="newPassword" (input)="this.onSearchTextChange($event)" [placeholder]="this.pageDetails().search" [value]="this.searchedText || ''" aria-label="Username" aria-describedby="basic-addon1">
        <button *ngIf="this.searchedText" (click)="this.clearSeacrhedText()" type="button" class="btn bg-transparent" style="margin-left: -45px; z-index: 100;">
          <i class="fa fa-times" style="content: url('/assets/images/home/cross.svg');"></i>
        </button>
      </div>
    </div>
    <hr style="width: 90%; margin: auto; border: 1px solid #F1F3F5; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
    <div *ngIf="this.shouldFiltersBevisible" style="width: 95%; margin: auto; margin-top: 10px; margin-bottom: 10px;">
      <button (click)="this.open(order)" style="width: fit-content; height: 40px; border-radius: 7px; padding: 10px; border: none; background-color: white;" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticOrder" aria-controls="staticBackdrop">
        {{ this.selectedOrder }} &nbsp;<i class="bi bi-caret-down-fill" style="position: relative; top: 2px;"></i>
      </button>
      <button style="margin-left: 10px; width: 40px; height: 40px; padding: 5px; border: none; background-color: white; float: right; border-radius: 7px;" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="staticBackdrop">
          <img src="/assets/images/home/icon-filter.svg" alt="">
      </button>

      <button (click)="this.toggleViewType()" style="width: 40px; height: 40px; padding: 5px; border: none; background-color: white; float: right; border-radius: 7px;" type="button">
        <img [src]="this.viewTypeIcon" alt="">
    </button>
  </div>
  </div>

  <div *ngIf="!this.searched" class="row" style="width: 90%; margin: auto; margin-top: 15px; background-color: white; border-radius: 9px;">
        <div class="col-3" style="text-align: center; padding: 10px;">
          <img style="position: relative;left: 2px;" (click)="this.onOptionsTap('categories', login)" src="/assets/images/home/marketplace-categories.svg">
          <br>
          <span>Категории</span>
        </div>
        <div class="col-3" style="text-align: center;  padding: 10px;">
          <img (click)="this.onOptionsTap('fav', login)" src="/assets/images/home/marketplace-fav.svg">
          <br>
          <span>Любими</span>
        </div>
        <div class="col-3" style="text-align: center;  padding: 10px;">
          <img (click)="this.onOptionsTap('myorders', login)" src="/assets/images/home/marketplace-myorders.svg" >
          <br>
          <span>Поръчки</span>
        </div>
        <div class="col-3" style="text-align: center;  padding: 10px;">
          <img (click)="this.onOptionsTap('returns', login)" src="/assets/images/home/marketplace-returns.svg" >
          <br>
          <span>Връщане</span>
        </div>
    </div>
    <!-- <ul class="nav justify-content-center" style="margin-top: 10px;">
        <li class="nav-item" style="background-color: white; color: black; font-weight: bold;">
            <a style="color: black;" class="nav-link active" aria-current="page" href="#">{{ this.pageDetails().sg1 }}</a>
        </li>
    </ul> -->
    <div *ngIf="!this.searched" style="margin-top: 10px; padding: 7px;">
        <div style="margin-top: 10px;" *ngFor="let category of this.rootCategories?.data">
            <p style="font-weight: 700;">{{ category.name }} <a style="float: right; color: #0A69EB; font-weight: 400; font-size: 0.9em;" (click)="this.goToCategory(category.uuid, category.name)">Виж всички</a></p>
            <div class="container-fluid" style="overflow: scroll;">
                <div class="row flex-row flex-nowrap">
                    <div [matBadge]="product.is_in_group ? 'Групова поръчка' : ''" matBadgeColor="warn" matBadgePosition="before"  style="text-align: center; height: 275px; padding: 10px; background-color: white; margin-right: 10px; width: 140px; border-radius: 9px;" (click)="this.openItem(product.uuid, category.uuid)" *ngFor="let product of this.getProductsPerCategory(category.uuid)">
                        <img *ngIf="this.productImage(product.uuid)" style="width: 120px; height: 130px" [src]="(this.productImage(product.uuid)) ? this.productImage(product.uuid) : '~/assets/images/shared/logo.jpg'" alt="">
                        <p style="margin-bottom: 5px; display: -webkit-box;-webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; height: 65px; overflow: hidden; text-overflow: ellipsis; text-align: center; margin-top: 5px; text-overflow: ellipsis;">{{ product.name }}</p>
                        <ngb-rating style="position: relative;" [readonly]="true" [max]="5" [(rate)]="product.ratingAvgValue!">
                          <ng-template let-fill="fill" let-index="index">
                            <i class="bi-star{{fill === 100 ? '-fill filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                          </ng-template>
                        </ngb-rating> <span style="color: #b0c4de; font-size: 10px;">{{ ' (' + product.ratings!.data.length  + ')' }}</span>
                        <app-price
                          *ngIf="product?.pricing?.length"
                          class="home-price"
                          [amount]="getSinglePricePerPiece(product.pricing)"
                          layout="auto"
                        >
                        </app-price>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="this.searchedText !== undefined  && this.searched" style="margin-top: 10px;" >
      <div *ngIf="(this.ds && !this.ds!.productsLength && !this.ds!.loading && this.ds2 && !this.ds2!.productsLength && !this.ds2!.loading) || noProducts" style="text-align: center;">
          <img src="/assets/images/home/nothing-found.svg" alt="" style="margin-top: 20px;">
          <h4 style="width: 90%; text-align: center; font-weight: 600; margin: auto; margin-top: 10px;">0 резултата за "{{this.searchedText}}"</h4>
          <p style="width: 90%; text-align: center; color: #ADAFBB; margin: auto; margin-top: 10px;">
            Провери дали думата, която търсиш е правилно изписана или опитай с друга дума
          </p>
      </div>
      <cdk-virtual-scroll-viewport *ngIf="this.viewType == productViewTypes.list" [itemSize]="170"  class="example-viewport" style="height: 72vh; overflow-x: hidden; width: 100%;">
            <div  *cdkVirtualFor="let item of ds; index as i; templateCacheSize: 0" [class]="this.viewType == productViewTypes.list ? 'example-item col-12' : 'example-item col-6'" [style]="this.viewType == productViewTypes.list ? 'height: 170px;' : ((i % 2 == 0) ? 'height: 320px; padding-right: 4.5px' : 'height: 320px; padding-left: 4.5px')">
              <div  *ngIf="item && this.viewType == productViewTypes.list" style="height: 170px;">
                <div [matBadge]="item.is_in_group ? 'Групова поръчка' : ''" matBadgeColor="warn" matBadgePosition="before" (click)="this.openItem(item.uuid, 'none')" class="card mb-3" style="border: unset; max-width: 540px; padding: 10px; background-color: white;  border-radius: 9px;">
                  <div class="row">
                    <div class="col-4">
                      <img [src]="item.imageURL" class="card-img img-fluid"  style="height: 120px;" alt="...">
                    </div>
                    <div class="col-8" style="padding: 0px; padding-right: 5px;">
                        <p style="margin-bottom: 5px; display: -webkit-box;-webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; height: 63px; overflow: hidden; text-overflow: ellipsis; margin-top: 5px; text-overflow: ellipsis;">{{ item?.name || '' }}</p>
                        <ngb-rating style="position: relative;" [readonly]="true" [max]="5" [(rate)]="item.ratingAvgValue!">
                          <ng-template let-fill="fill" let-index="index">
                            <i class="bi-star{{fill === 100 ? '-fill filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                          </ng-template>
                        </ngb-rating> <span style="color: #b0c4de; font-size: 10px;">{{ ' (' + item.ratings!.data.length  + ')' }}</span>
                        <app-price
                          *ngIf="item?.pricing?.length"
                          class="home-price"
                          [amount]="getSinglePricePerPiece(item.pricing)"
                        >
                        </app-price>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </cdk-virtual-scroll-viewport>
      <cdk-virtual-scroll-viewport *ngIf="this.viewType == productViewTypes.grid" [itemSize]="320" class="example-viewport" style="height: 72vh; overflow-x: hidden; width: 100%;">
            <div  *cdkVirtualFor="let item of ds2; index as i; templateCacheSize: 0" class="example-item col-12" [style]="this.viewType == productViewTypes.list ? 'height: 170px;' : 'height: 320px;'">
             <div class="row">
              <div *ngFor="let rowItem of item; index as i" class="col-6" [style]="this.viewType == productViewTypes.list ? 'height: 170px;' : ((i % 2 == 0) ? 'height: 320px; padding-right: 3.5px' : 'height: 320px; padding-left: 3.5px')">
                <div  *ngIf="rowItem && this.viewType == productViewTypes.grid" style="height: 320px">
                  <div [matBadge]="rowItem.is_in_group ? 'Групова поръчка' : ''" matBadgeColor="warn" matBadgePosition="before" (click)="this.openItem(rowItem.uuid, 'none')" class="card mb-3" style="min-height: 290px; border: unset; padding: 10px; background-color: white;  border-radius: 9px;">
                    <div class="row">
                      <div class="col-12">
                        <img [src]="rowItem.imageURL" class="card-img img-fluid"  style="height: 160px;" alt="...">
                      </div>
                      <div class="col-12" style="text-align: center;">
                          <p style="margin-bottom: 5px; display: -webkit-box;-webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; height: 63px; overflow: hidden; text-overflow: ellipsis; margin-top: 5px; text-overflow: ellipsis;">{{ rowItem?.name || '' }}</p>
                          <ngb-rating style="position: relative;" [readonly]="true" [max]="5" [(rate)]="rowItem.ratingAvgValue!">
                            <ng-template let-fill="fill" let-index="index">
                              <i class="bi-star{{fill === 100 ? '-fill filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                            </ng-template>
                          </ngb-rating> <span style="color: #b0c4de; font-size: 10px;">{{ ' (' + rowItem.ratings!.data.length  + ')' }}</span>
                          <app-price
                            *ngIf="rowItem?.pricing?.length"
                            class="home-price"
                            [amount]="getSinglePricePerPiece(rowItem.pricing)"
                          >
                          </app-price>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             </div>
            </div>
      </cdk-virtual-scroll-viewport>
    </div>
</div>

<div style="width: 80vw;" class="offcanvas offcanvas-end"  tabindex="-1" id="staticBackdrop" aria-labelledby="staticBackdropLabel">
    <div class="offcanvas-header" style="height: 5vh;">
      <h3 class="offcanvas-title" id="staticBackdropLabel" style="margin-top: 20px; font-weight: 600;">Филтри</h3>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body" style="height: 85vh;">

      <div *ngIf="this.category">
        <p style="font-weight: 700;">Цена</p>
        <div style="width: 90%; margin: auto;" *ngIf="this.options.ceil">
          <ngx-slider [(value)]="this.minValue" [(highValue)]="this.maxValue" [options]="this.options"></ngx-slider>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
      </div>

      <p style="font-weight: 700; margin: 0 0 15px;" (click)="this.openCategories(categories)">{{ this.selectedFilterCategory || 'Категория' }}<span style="color: #ADAFBB; float: right; font-weight: normal;">Избери <img src="/assets/images/shared/arrow.svg" style="height: 15px; width: 15px;"></span></p>

      <div *ngIf="this.availableFilterOptions.length">
        <div *ngFor="let option of this.availableFilterOptions">
          <div *ngIf="option.key == 'Пол'">
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <div *ngIf="this.isAreaExpanded(option.key)">
              <p style="font-weight: 700;">{{ option.key }} </p>
              <div class="form-check" *ngFor="let value of option.value">
                <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="value.value" [id]="option.key + '-' + value.value">
                <label class="form-check-label" [for]="option.key + '-' + value.value">
                  {{value.text}}
                </label>
              </div>
              <p style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea(option.key, false)">Скрий</p>
           </div>
            <div *ngIf="!this.isAreaExpanded(option.key)">
              <p style="font-weight: 700;">{{ option.key }} </p>
              <div class="form
              -check" *ngFor="let value of this.getFirstOptions(option.value); index as i">
                <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="value.value" [id]="option.key + '-' + value.value">
                <label class="form-check-label" [for]="option.key + '-' + value.value">
                  {{value.text}}
                </label>
              </div>
              <p *ngIf="option.value.length > maxOptionsPerFilter" style="margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea(option.key, true)">Виж всички</p>
            </div>
          </div>
        </div>
      </div>

      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">

      <p style="font-weight: 700;">Безплатна доставка</p>
      <div class="form-check">
        <input (change)="this.delivery = undefined" [checked]="this.delivery === undefined" class="form-check-input" type="radio" name="delivery" id="delivery3">
        <label class="form-check-label" for="delivery3">
          Всички
        </label>
      </div>
      <div class="form-check">
        <input (change)="this.delivery = true" [checked]="this.delivery === true" class="form-check-input" type="radio" name="delivery" id="delivery1">
        <label class="form-check-label" for="delivery1">
          Да
        </label>
      </div>
      <div class="form-check">
        <input (change)="this.delivery = false" [checked]="this.delivery === false" class="form-check-input" type="radio" name="delivery" id="delivery2" checked>
        <label class="form-check-label" for="delivery2">
          Не
        </label>
      </div>
      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">

      <p style="font-weight: 700;">Група </p>
      <div class="form-check">
        <input (change)="this.group = undefined" [checked]="this.group === undefined" class="form-check-input" type="radio" name="group" id="group3">
        <label class="form-check-label" for="group3">
          Всички
        </label>
      </div>
      <div class="form-check">
        <input (change)="this.group = true"  [checked]="this.group === true" class="form-check-input" type="radio" name="group" id="group1">
        <label class="form-check-label" for="group1">
          Да
        </label>
      </div>
      <div class="form-check">
        <input (change)="this.group = false" [checked]="this.group === false" class="form-check-input" type="radio" name="group" id="group2" checked>
        <label class="form-check-label" for="group2">
          Не
        </label>
      </div>
      <div *ngIf="this.areAvailableFiltersSet && this.isAreaExpanded('brands')">
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <p style="font-weight: 700;">Марка </p>
        <div class="form-check" *ngFor="let brand of this.availableFilterBrands">
          <input (change)="this.brandUpdated($event)" [checked]="this.shouldBrandBeChecked(brand.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="brand.value" [id]="brand.value">
          <label class="form-check-label" [for]="brand.value">
            {{brand.key}}
          </label>
        </div>
        <p style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('brands', false)">Скрий</p>
      </div>

      <div *ngIf="this.areAvailableFiltersSet && !this.isAreaExpanded('brands')">
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <p style="font-weight: 700;">Марка </p>
        <div class="form-check" *ngFor="let brand of this.getFirst(this.availableFilterBrands); index as i;">
          <input (change)="this.brandUpdated($event)" [checked]="this.shouldBrandBeChecked(brand.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="brand.value" [id]="brand.value">
          <label class="form-check-label" [for]="brand.value">
            {{brand.key}}
          </label>
        </div>
        <p *ngIf="this.availableFilterBrands.length > maxOptionsPerFilter" style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('brands', true)">Виж всички</p>
      </div>

      <div *ngIf="this.areAvailableFiltersSet && this.isAreaExpanded('partners')">
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <p style="font-weight: 700;">Партньори </p>
        <div class="form-check" *ngFor="let partner of this.availableFilterPartners">
          <input (change)="this.partnerUpdated($event)" [checked]="this.shouldPartnerBeChecked(partner.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="partner.value" [id]="partner.value">
          <label class="form-check-label" [for]="partner.value">
            {{partner.key}}
          </label>
        </div>
        <p  style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('partners', false)">Скрий</p>
      </div>

      <div *ngIf="this.areAvailableFiltersSet && !this.isAreaExpanded('partners')">
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <p style="font-weight: 700;">Партньори </p>
        <div class="form-check" *ngFor="let partner of this.getFirst(this.availableFilterPartners); index as i;">
          <input (change)="this.partnerUpdated($event)" [checked]="this.shouldPartnerBeChecked(partner.value)" style="position: relative; top: -3px;" class="form-check-input" type="checkbox" [value]="partner.value" [id]="partner.value">
          <label class="form-check-label" [for]="partner.value">
            {{partner.key}}
          </label>
        </div>
        <p *ngIf="this.availableFilterPartners.length > maxOptionsPerFilter" style="margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea('partners', true)">Виж всички</p>
      </div>
      <div *ngIf="this.availableFilterOptions.length">
        <div *ngFor="let option of this.availableFilterOptions">
          <div *ngIf="option.key != 'Пол'">
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <div *ngIf="this.isAreaExpanded(option.key)">
              <p style="font-weight: 700;">{{ option.key }} </p>
              <div class="form-check" *ngFor="let value of option.value">
                <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name) " style="position: relative; top: -1px;" class="form-check-input" [type]="option.value.type == 'radio' ? 'radio' : 'checkbox'" [value]="value.value" [id]="option.key + '-' + value.text">
                <label class="form-check-label" [for]="option.key + '-' + value.text"  [style]="option.key == 'Цвят' ? 'position: relative; top: -4px;' : ''">
                  <span *ngIf="option.key == 'Цвят'"> <img *ngIf="value.text.includes('Многоцветен')" style="display: inline-block;height: 20px;width: 20px;position: relative; top: 5px;"  src="/assets/images/product/colorful.svg" alt=""><span *ngIf="!value.text.includes('Многоцветен')" [style]="(!value.text.includes('Бял')) ? 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; background-color: '+ this.getColor(value.text) : 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; border: 1px solid black'"></span></span>
                  {{value.text}}
                </label>
              </div>
              <p style=" margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea(option.key, false)">Скрий</p>

            </div>
            <div *ngIf="!this.isAreaExpanded(option.key)">
              <p style="font-weight: 700;">{{ option.key }} </p>
              <div class="form-check" *ngFor="let value of this.getFirstOptions(option.value); index as i">
                <input (change)="this.optionUpdated(value.value, value.field_name, option.value.type)" [checked]="this.shouldOptionBeChecked(value.value, value.field_name)" style="position: relative; top: -1px;" class="form-check-input" [type]="option.value.type == 'radio' ? 'radio' : 'checkbox'" [value]="value.value" [id]="option.key + '-' + value.text">
                <label class="form-check-label" [for]="option.key + '-' + value.text" [style]="option.key == 'Цвят' ? 'position: relative; top: -4px;' : ''">
                 <span *ngIf="option.key == 'Цвят'"> <img *ngIf="value.text.includes('Многоцветен')" style="display: inline-block;height: 20px;width: 20px;position: relative; top: 5px;"  src="/assets/images/product/colorful.svg" alt=""><span *ngIf="!value.text.includes('Многоцветен')" [style]="(!value.text.includes('Бял')) ? 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; background-color: '+ this.getColor(value.text) : 'display: inline-block;height: 20px;width: 20px;position: relative; top: 5px; border: 1px solid black'"></span></span>
                 {{value.text}}
                </label>
              </div>
              <p *ngIf="option.value.length > maxOptionsPerFilter" style="margin-top: 7px; color: #0A69EB;" (click)="this.setExpandedArea(option.key, true)">Виж всички</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 10vh;">
      <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 5px;">
      <div class="row justify-content-around">
        <button type="button" class="btn btn-primary col-4" style="width: 90%; margin: auto; background-color: #E4F2FE; color: #0A69EB;" (click)="this.clear(true)">Изчисти</button>
        <button data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="offcanvasExample" type="button" class="btn btn-primary col-4" style="width: 90%; margin: auto;" (click)="this.filter()">Филтрирай</button>
      </div>
    </div>
  </div>

  <ng-template #order let-modal>
    <div style="padding-top: 10px !important; padding-bottom: 10px !important;">
      <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">Подреди по:</h3>
      <!-- <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
      <div style="width: 100%;">
        <ul class="list-group list-group-flush" style="width: 80%; margin: auto; list-style-type: none;">
          <li style="position: relative; top: -5px;"  (click)="this.selectOrder('rating', 'rate', modal)" [id]="this.selectedOrder == 'Най-популярни' ? 'active' : ''"> Най-популярни</li>
          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
          <li style="position: relative; top: -5px;" (click)="this.selectOrder('newest', 'new', modal)" [id]="this.selectedOrder == 'Най-нови' ? 'active' : ''">Най-нови</li>
          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
          <li style="position: relative; top: -5px;" (click)="this.selectOrder('price', 'price', modal)" [id]="this.selectedOrder == 'Най-ниска цена' ? 'active' : ''">Най-ниска цена</li>
          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
          <li style="position: relative; top: -5px;" (click)="this.selectOrder('-price', 'maxprice', modal)" [id]="this.selectedOrder == 'Най-висока цена' ? 'active' : ''">Най-висока цена</li>
        </ul>
      </div>
    </div>
  </ng-template>

<ng-template #login let-modal>
  <div style="text-align: center;">
      <img src="/assets/images/account/image-login.png" alt="" style="height: 140px; width: 160px; margin-top: 30px; margin-bottom: 20px;"> <br>
      <p style="font-weight: bold; margin-top: 7px;">Влез в профила си за да продължиш</p>
  </div>
  <div class="row" style="margin-top: 25px; margin-bottom: 15px;">
      <div class="col-6" style="text-align: center;">
          <button class="btn btn-primary" style="border-color: transparent; width: 90%; background-color: #E4F2FE; color: #0A69EB" mat-button (click)="this.registration(modal)">Регистрация</button>

      </div>
      <div class="col-6" style="text-align: center;">
          <button class="btn btn-primary" style="width: 90%;"  mat-button (click)="this.loginNavigation(modal)">Влез</button>
      </div>
  </div>
</ng-template>

<ng-template #voucher let-modal>
  <div style="text-align: center;">
      <img src="/assets/images/vouchers/voucher-init.svg" alt="" style="height: 140px; width: 160px; margin-top: 30px; margin-bottom: 20px;"> <br>
      <p style="font-weight: bold; margin-top: 7px;">Добре дошли!</p>
      <p>
        Като един от първите регистрирали се получавате подарък ваучер на стойност:
      </p>
      <div class="welcome-voucher-amount" aria-label="Ваучер на стойност 5.12 евро">
        5.12 евро
      </div>

  </div>
  <div class="row" style="margin-top: 25px; margin-bottom: 15px;">
      <div class="col-12" style="text-align: center;">
          <button class="btn btn-primary" style="width: 90%;"  mat-button (click)="this.close(modal)">Затвори</button>
      </div>
  </div>
</ng-template>

<ng-template #voucherInit let-modal>
  <div style="text-align: center;">
      <img src="/assets/images/vouchers/voucher-init.svg" alt="" style="height: 140px; width: 160px; margin-top: 30px; margin-bottom: 20px;"> <br>
      <p style="font-weight: bold; margin-top: 7px; font-size: 18px;">Регистрирай се сега и вземи ваучер на стойност <span style="color: #0A69EB">5.12 евро</span>!</p>
      <p>
        Като един от първите регистрирали ще получите подарък ваучер на стойност 5.12 евро
      </p>
  </div>
  <div class="row" style="margin-top: 25px; margin-bottom: 15px;">
    <div class="col-6" style="text-align: center;">
      <button class="btn btn-primary" style="border-color: transparent; width: 90%; background-color: #E4F2FE; color: #0A69EB" mat-button (click)="this.close(modal)">Не сега</button>

    </div>
    <div class="col-6" style="text-align: center;">
        <button class="btn btn-primary" style="width: 90%;"  mat-button (click)="this.registration(modal)">Регистрирай се</button>
    </div>
  </div>
</ng-template>


<ng-template #categories let-modal>
  <ul class="list-group">
    <li class="list-group-item" (click)="this.selectCategory('', modal)">Изчисти</li>
    <li class="list-group-item" (click)="this.selectCategory(category.uuid, modal)" *ngFor="let category of this.filterCategories.data">{{category.name}}</li>
  </ul>
</ng-template>
